"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBButton = exports.IMBButtonHoverVariant = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var polished_1 = require("polished");
var core_1 = require("@material-ui/core");
var mock_1 = require("../../utils/mock");
var KeyboardButton_1 = require("../KeyboardButton");
var IMBButtonHoverVariant;
(function (IMBButtonHoverVariant) {
    IMBButtonHoverVariant[IMBButtonHoverVariant["elevate"] = 0] = "elevate";
    IMBButtonHoverVariant[IMBButtonHoverVariant["highlight"] = 1] = "highlight";
    IMBButtonHoverVariant[IMBButtonHoverVariant["darken"] = 2] = "darken";
})(IMBButtonHoverVariant = exports.IMBButtonHoverVariant || (exports.IMBButtonHoverVariant = {}));
var NormalizedButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  // fix for Firefox & safari\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n\n  // fix for IE & Edge\n  overflow: visible;\n  text-transform: none;\n\n  // fix for iOS & Safari\n  -webkit-appearance: button;\n"], ["\n  // fix for Firefox & safari\n  font-family: inherit;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n\n  // fix for IE & Edge\n  overflow: visible;\n  text-transform: none;\n\n  // fix for iOS & Safari\n  -webkit-appearance: button;\n"])));
exports.MBButton = styled_components_1.default(function (_a) {
    var _b, _c;
    var width = _a.width, height = _a.height, padding = _a.padding, textVariant = _a.textVariant, disabled = _a.disabled, background = _a.background, borderRadius = _a.borderRadius, maxWidth = _a.maxWidth, minWidth = _a.minWidth, color = _a.color, border = _a.border, hover = _a.hover, borderTop = _a.borderTop, borderLeft = _a.borderLeft, borderRight = _a.borderRight, borderBottom = _a.borderBottom, justifyContent = _a.justifyContent, mr = _a.mr, ml = _a.ml, mb = _a.mb, mt = _a.mt, m = _a.m, flex = _a.flex, hoverVariant = _a.hoverVariant, onClick = _a.onClick, _d = _a.type, type = _d === void 0 ? 'button' : _d, Icon = _a.Icon, children = _a.children, shortcutKeyInfo = _a.shortcutKeyInfo, rootBoxProps = _a.rootBoxProps, boxShadow = _a.boxShadow, props = __rest(_a, ["width", "height", "padding", "textVariant", "disabled", "background", "borderRadius", "maxWidth", "minWidth", "color", "border", "hover", "borderTop", "borderLeft", "borderRight", "borderBottom", "justifyContent", "mr", "ml", "mb", "mt", "m", "flex", "hoverVariant", "onClick", "type", "Icon", "children", "shortcutKeyInfo", "rootBoxProps", "boxShadow"]);
    mock_1.mockFunction({
        width: width,
        height: height,
        padding: padding,
        textVariant: textVariant,
        background: background,
        borderRadius: borderRadius,
        maxWidth: maxWidth,
        minWidth: minWidth,
        color: color,
        border: border,
        hover: hover,
        borderTop: borderTop,
        borderLeft: borderLeft,
        borderRight: borderRight,
        borderBottom: borderBottom,
        justifyContent: justifyContent,
        boxShadow: boxShadow,
        mr: mr,
        ml: ml,
        mb: mb,
        mt: mt,
        m: m,
        flex: flex,
        hoverVariant: hoverVariant,
        rootBoxProps: rootBoxProps,
    });
    var handleClick = function (e) {
        !disabled && onClick && onClick(e);
    };
    return (jsx_runtime_1.jsxs(NormalizedButton, __assign({ onClick: handleClick }, props, { type: type, disabled: disabled }, { children: [shortcutKeyInfo && jsx_runtime_1.jsx(ButtonShortcutHint, __assign({}, shortcutKeyInfo), void 0),
            jsx_runtime_1.jsxs(core_1.Box, __assign({ display: "flex", alignItems: "center" }, rootBoxProps, { children: [Icon && Icon.position !== 'right' && (jsx_runtime_1.jsx(core_1.Box, __assign({ mr: children ? 1 : 0, display: "flex" }, { children: jsx_runtime_1.jsx(Icon.component, __assign({ size: 20 }, ((_b = Icon.props) !== null && _b !== void 0 ? _b : {})), void 0) }), void 0)), children, Icon && Icon.position === 'right' && (jsx_runtime_1.jsx(core_1.Box, __assign({ ml: children ? 1 : 0, display: "flex" }, { children: jsx_runtime_1.jsx(Icon.component, __assign({ size: 20 }, ((_c = Icon.props) !== null && _c !== void 0 ? _c : {})), void 0) }), void 0))] }), void 0)] }), void 0));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  max-width: ", ";\n  min-width: ", ";\n  height: ", ";\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  \n  display: flex;\n  align-items: center;\n  ", "\n\n  text-decoration: none;\n\n  cursor: pointer;\n  transition: 0.2s all ease-in-out;\n\n  text-transform: inherit;\n\n  ", "\n\n  padding: ", ";\n\n  transition: all 0.2s ease-in-out;\n\n  box-sizing: border-box;\n  position: relative;\n\n\n  \n    :hover {\n      ", "\n      }\n    }\n\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  \n  ", "\n"], ["\n  ",
    "\n  max-width: ", ";\n  min-width: ", ";\n  height: ",
    ";\n\n  ",
    "\n\n  ",
    "\n  ", "\n  ", "\n  ",
    "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  \n  display: flex;\n  align-items: center;\n  ", "\n\n  text-decoration: none;\n\n  cursor: pointer;\n  transition: 0.2s all ease-in-out;\n\n  text-transform: inherit;\n\n  ", "\n\n  padding: ", ";\n\n  transition: all 0.2s ease-in-out;\n\n  box-sizing: border-box;\n  position: relative;\n\n\n  \n    :hover {\n      ",
    "\n      }\n    }\n\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  \n  ", "\n"])), function (_a) {
    var width = _a.width, fullWidth = _a.fullWidth;
    return fullWidth
        ? 'width: 100%;'
        : width
            ? typeof width === 'string'
                ? "width: " + width + ";"
                : "width: " + width + "px;"
            : '';
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? maxWidth + "px" : '100%');
}, function (_a) {
    var minWidth = _a.minWidth;
    return minWidth && minWidth + "px";
}, function (_a) {
    var height = _a.height;
    return Number.isInteger(height) ? height + "px" : "" + height;
}, function (_a) {
    var theme = _a.theme, textVariant = _a.textVariant;
    return textVariant ? theme.typography[textVariant] : '';
}, function (_a) {
    var background = _a.background;
    return background
        ? "background-color: " + background + ";"
        : "background-color: white;";
}, function (_a) {
    var border = _a.border;
    return (border ? "border: " + border + ";" : "border: 1px solid #000;");
}, function (_a) {
    var color = _a.color;
    return color && "color: " + color + ";";
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return typeof borderRadius === 'string'
        ? "border-radius: " + borderRadius + ";"
        : typeof borderRadius === 'number'
            ? "border-radius: " + borderRadius + "px;"
            : 'border-radius: 4px;';
}, function (_a) {
    var borderLeft = _a.borderLeft;
    return borderLeft && "border-left: " + borderLeft + ";";
}, function (_a) {
    var borderRight = _a.borderRight;
    return borderRight && "border-right: " + borderRight + ";";
}, function (_a) {
    var borderTop = _a.borderTop;
    return borderTop && "border-top: " + borderTop + ";";
}, function (_a) {
    var borderBottom = _a.borderBottom;
    return borderBottom && "border-bottom: " + borderBottom + ";";
}, function (_a) {
    var boxShadow = _a.boxShadow;
    return boxShadow && "box-shadow: " + boxShadow + ";";
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return "justify-content: " + (justifyContent !== null && justifyContent !== void 0 ? justifyContent : 'center') + ";";
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "opacity: 0.2;";
}, function (_a) {
    var padding = _a.padding;
    return (padding ? "" + padding : '7.5px 16px');
}, function (_a) {
    var disabled = _a.disabled, hover = _a.hover, _b = _a.hoverVariant, hoverVariant = _b === void 0 ? IMBButtonHoverVariant.elevate : _b, theme = _a.theme, background = _a.background;
    if (disabled) {
        return "";
    }
    if (hover) {
        return hover;
    }
    switch (hoverVariant) {
        case IMBButtonHoverVariant.highlight: {
            var lightenBackground = background
                ? polished_1.lighten(0.1, background)
                : theme.colors.offwhite[300];
            return "\n            background: " + lightenBackground + ";";
        }
        case IMBButtonHoverVariant.darken: {
            var darkenBg = background
                ? background === 'transparent'
                    ? 'rgba(9, 9, 9, 0.05)'
                    : polished_1.darken(0.1, background)
                : theme.colors.offwhite[100];
            return "\n            background: " + darkenBg + ";";
        }
        case IMBButtonHoverVariant.elevate: {
            return "\n            transform: translate(0, -2px) scale(1.01);\n            box-shadow: 5px 5px rgba(0, 0, 0, 0.2);";
        }
        default:
            return "";
    }
}, function (_a) {
    var mr = _a.mr, theme = _a.theme;
    return mr && "margin-right: " + theme.spacing(mr) + "px";
}, function (_a) {
    var ml = _a.ml, theme = _a.theme;
    return ml && "margin-left: " + theme.spacing(ml) + "px";
}, function (_a) {
    var mt = _a.mt, theme = _a.theme;
    return mt && "margin-top: " + theme.spacing(mt) + "px";
}, function (_a) {
    var mb = _a.mb, theme = _a.theme;
    return mb && "margin-bottom: " + theme.spacing(mb) + "px";
}, function (_a) {
    var m = _a.m, theme = _a.theme;
    return m && "margin: " + theme.spacing(m) + "px";
}, function (_a) {
    var flex = _a.flex;
    return flex && "flex: " + flex + ";";
});
var ButtonShortcutHint = function (_a) {
    var targetKey = _a.targetKey, _b = _a.hidden, hidden = _b === void 0 ? false : _b, _c = _a.shouldListen, shouldListen = _c === void 0 ? true : _c;
    return (jsx_runtime_1.jsx(core_1.Box, __assign({ position: "absolute", top: -8, hidden: hidden }, { children: jsx_runtime_1.jsx(KeyboardButton_1.KeyboardButton, { targetKey: targetKey, shouldListen: shouldListen }, void 0) }), void 0));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=MBButton.js.map